import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

import { getTimeseriesData } from "api/dashboard";

import getLogger from "utils/logger.util";
import { timestampInDefaultFormat } from "utils/utils";

import ErrorLabel from "components/ErrorLabel";
import PageLoading from "components/PageLoading";

import { getTagDataPayload, parseTimeseriesData } from "./TimeseriesDataParser";

import "./TimeseriesChart.scss";

const TimeseriesPlotly = props => {
  const Logger = getLogger("TimeseriesPlotly");
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isError, setIsError] = useState();
  const [plotyData, setPlotlyData] = useState(null);

  const chartHeight = `${props.isSmartInsight ? 100 : 150}px`;

  useEffect(async () => {
    try {
      const payload = getTagDataPayload(props);
      const resp = await getTimeseriesData(payload);
      if (resp && resp.data && resp.data.Time?.length) {
        const { startTime, endTime } = payload;
        let xAxisRange = null;
        if (startTime && endTime) {
          xAxisRange = [timestampInDefaultFormat(startTime), timestampInDefaultFormat(endTime)];
        }
        const isModeBar = !(props.isSmartInsight || props.isDaySeries);
        const plotlyData = parseTimeseriesData(props.tagData, resp.data, xAxisRange, isModeBar);
        Logger.log("Timeseries Plotly Data: ", props, plotlyData);
        setPlotlyData(plotlyData);
      } else {
        setIsError(true);
      }
    } catch (err) {
      Logger.error("Error while fetching data: ", err);
    } finally {
      setIsDataLoading(false);
    }
  }, []);

  return (
    <>
      {isDataLoading ? (
        <PageLoading customHeight={chartHeight} />
      ) : isError ? (
        <div className="errorLabel" style={{ height: chartHeight }}>
          <ErrorLabel message={"No Data Found"} />
        </div>
      ) : (
        plotyData && (
          <div id="timeseries-chart-container" className={props.className} style={{ height: chartHeight }}>
            <Plot {...plotyData} style={{ width: "100%", height: "100%" }} />
          </div>
        )
      )}
    </>
  );
};

export default TimeseriesPlotly;
